import { render, staticRenderFns } from "./YandexCaptcha.vue?vue&type=template&id=21de42ec"
import script from "./YandexCaptcha.vue?vue&type=script&lang=js"
export * from "./YandexCaptcha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports